import React from 'react';

// ============================================================
// ActivityPage — Session 1 (Phase 2 shell) placeholder.
// Full implementation lands in a later session; this file exists so
// AdminShell's page router has something to render for its slug and
// the shell can be verified end-to-end before any real data is wired.
//
// Firestore cost when this placeholder mounts: ZERO reads/writes.
// ============================================================

export default function ActivityPage() {
  return (
    <div className="sa-page-placeholder">
      <div className="sa-page-placeholder-icon">🛠️</div>
      <div className="sa-page-placeholder-title">Coming in a future session</div>
      <div className="sa-page-placeholder-text">
        A chronological audit log of admin actions will land here once the /adminAuditLog collection ships.
      </div>
    </div>
  );
}
